<template lang="pug">
  footer.wp-footer.container-fluid
    p &copy; Copyright 2020 Best Seat In The House (Jamaica)
</template>

<script lang="js">

export default {
  name: 'wp-footer',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
@import "@/scss/breakpoint";

.wp-footer {
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: 0;
  width: 100%;
  /* background: #012; */
  background: #000b18;
  text-align: center;
  padding: 5em 1em 1em;
  min-height: 15em;
  color: white;
  @include for-mobile {
    padding: 1em;
    min-height: 4em;
  }
}
</style>
